module.exports = "/_next/static/resources/photo-4-70dd4463827b655eb7dafaa8c58a2d45.jpg";